import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EDistinct,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutPricingOverview = {
  factory: EElement({
    id: '32eb350c-f0ed-6327-a271-bbdd5da15c55',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('8c144b21-a78d-8b79-7b48-7c065aae3b67')]),
      children: EList([
        EElement({
          id: 'ea3f1418-17a7-02cd-f218-bf7bfb50d475',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '483e6800-d49b-ed51-1526-6b65b019d1c0',
                type: qualify(Plugins.name('Basic'), Component.name('Heading')),
                data: ERecord({
                  tag: EEnum('h2'),
                  styleBlockIds: EList([
                    EText('9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4'),
                  ]),
                  children: EList([
                    EElement({
                      id: '483e6800-d49b-ed51-1526-6b65b019d1c1',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Pricing section'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '4d154b10-caa3-0b62-d682-0384a457035c',
                type: qualify(
                  Plugins.name('Basic'),
                  Component.name('Paragraph')
                ),
                data: ERecord({
                  styleBlockIds: EList([
                    EText('9f394b53-0806-d03f-c322-35b26b4185aa'),
                  ]),
                  children: EList([
                    EElement({
                      id: '4d154b10-caa3-0b62-d682-0384a457035d',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText(
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem. Etiam sodales ac felis id interdum.'
                      ),
                    }),
                    EElement({
                      id: 'ebe03afb-4cba-bddb-a36b-fd43fc66a3ca',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('LineBreak')
                      ),
                      data: ERecord({}),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '717f3272-6e0a-741a-737f-b06fe88873e7',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('f4469efc-b695-3bd1-b5e9-8b420bdd7083'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'f7ef5c1d-85a8-8f27-8440-8b1500a54bfb',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('e69d9731-ab10-60ba-bae3-4b425a23b278'),
                        ]),
                        children: EList([
                          EElement({
                            id: '2376521e-343e-46c0-4179-0c0707a893d2',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageGallery),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"62737726dc39a9e1faf79d82"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('6a135e2f-ce26-a9d6-d3a3-36af6d58d4b6'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '1c0a05cb-e107-7855-c015-a1a09ed7fa0b',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h3'),
                              children: EList([
                                EElement({
                                  id: '1c0a05cb-e107-7855-c015-a1a09ed7fa0c',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Lorem ipsum dolor'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '10fcbb7b-c3c3-f1ad-92b9-63d3be510f91',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('894fc6fe-051f-d24c-68ed-7dd9b8d01d84'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '10fcbb7b-c3c3-f1ad-92b9-63d3be510f92',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. '
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '8bc76941-41a5-aaca-2804-b2599d42c85d',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              block: EText('inline'),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8829443b-f005-1554-a272-e89504531e07'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '8bc76941-41a5-aaca-2804-b2599d42c85e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    children: EList([
                                      EElement({
                                        id: '8bc76941-41a5-aaca-2804-b2599d42c85f',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Learn more'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '8bc76941-41a5-aaca-2804-b2599d42c860',
                                  type: qualify(
                                    Plugins.name('Embed'),
                                    Component.name('HtmlEmbed')
                                  ),
                                  data: ERecord({
                                    embed: ERecord({
                                      type: EText('html'),
                                      meta: ERecord({
                                        html: EText(
                                          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                        ),
                                        div: EBoolean(false),
                                        iframe: EBoolean(false),
                                        script: EBoolean(false),
                                        compilable: EBoolean(false),
                                      }),
                                    }),
                                    insideRTE: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                      ),
                                    ]),
                                    value: EText(
                                      '<svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                    ),
                                    content: EDistinct({
                                      name: qualify(
                                        Plugins.name('Embed'),
                                        typeName('CodeProp')
                                      ),
                                      value: EText(''),
                                    }),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'd82c29f5-5218-3e84-b057-ec60bd77b6cb',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('e69d9731-ab10-60ba-bae3-4b425a23b278'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'd82c29f5-5218-3e84-b057-ec60bd77b6cc',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageCards),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"62737726dc39a9e1faf79d7a"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('6a135e2f-ce26-a9d6-d3a3-36af6d58d4b6'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'd82c29f5-5218-3e84-b057-ec60bd77b6cd',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h3'),
                              children: EList([
                                EElement({
                                  id: 'd82c29f5-5218-3e84-b057-ec60bd77b6ce',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Lorem ipsum dolor'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd82c29f5-5218-3e84-b057-ec60bd77b6cf',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('894fc6fe-051f-d24c-68ed-7dd9b8d01d84'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd82c29f5-5218-3e84-b057-ec60bd77b6d0',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. '
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd82c29f5-5218-3e84-b057-ec60bd77b6d1',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              block: EText('inline'),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8829443b-f005-1554-a272-e89504531e07'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd82c29f5-5218-3e84-b057-ec60bd77b6d2',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    children: EList([
                                      EElement({
                                        id: 'd82c29f5-5218-3e84-b057-ec60bd77b6d3',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Learn more'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'd82c29f5-5218-3e84-b057-ec60bd77b6d4',
                                  type: qualify(
                                    Plugins.name('Embed'),
                                    Component.name('HtmlEmbed')
                                  ),
                                  data: ERecord({
                                    embed: ERecord({
                                      type: EText('html'),
                                      meta: ERecord({
                                        html: EText(
                                          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                        ),
                                        div: EBoolean(false),
                                        iframe: EBoolean(false),
                                        script: EBoolean(false),
                                        compilable: EBoolean(false),
                                      }),
                                    }),
                                    insideRTE: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                      ),
                                    ]),
                                    value: EText(
                                      '<svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                    ),
                                    content: EDistinct({
                                      name: qualify(
                                        Plugins.name('Embed'),
                                        typeName('CodeProp')
                                      ),
                                      value: EText(''),
                                    }),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'd9273550-969b-fe8a-0a81-ec522b510f29',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('e69d9731-ab10-60ba-bae3-4b425a23b278'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'd9273550-969b-fe8a-0a81-ec522b510f2a',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageMountains),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"62737726dc39a9e1faf79da8"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('6a135e2f-ce26-a9d6-d3a3-36af6d58d4b6'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'd9273550-969b-fe8a-0a81-ec522b510f2b',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h3'),
                              children: EList([
                                EElement({
                                  id: 'd9273550-969b-fe8a-0a81-ec522b510f2c',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Lorem ipsum dolor'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd9273550-969b-fe8a-0a81-ec522b510f2d',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('894fc6fe-051f-d24c-68ed-7dd9b8d01d84'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd9273550-969b-fe8a-0a81-ec522b510f2e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. '
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'd9273550-969b-fe8a-0a81-ec522b510f2f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              eventIds: EList([]),
                              block: EText('inline'),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8829443b-f005-1554-a272-e89504531e07'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd9273550-969b-fe8a-0a81-ec522b510f30',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    children: EList([
                                      EElement({
                                        id: 'd9273550-969b-fe8a-0a81-ec522b510f31',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Learn more'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'd9273550-969b-fe8a-0a81-ec522b510f32',
                                  type: qualify(
                                    Plugins.name('Embed'),
                                    Component.name('HtmlEmbed')
                                  ),
                                  data: ERecord({
                                    embed: ERecord({
                                      type: EText('html'),
                                      meta: ERecord({
                                        html: EText(
                                          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                        ),
                                        div: EBoolean(false),
                                        iframe: EBoolean(false),
                                        script: EBoolean(false),
                                        compilable: EBoolean(false),
                                      }),
                                    }),
                                    insideRTE: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                      ),
                                    ]),
                                    value: EText(
                                      '<svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M11.72 15L16.3472 10.357C16.7732 9.92932 16.7732 9.23603 16.3472 8.80962L11.72 4.16667L10.1776 5.71508L12.9425 8.4889H4.16669V10.6774H12.9425L10.1776 13.4522L11.72 15Z" fill="currentColor"/>\n</svg>'
                                    ),
                                    content: EDistinct({
                                      name: qualify(
                                        Plugins.name('Embed'),
                                        typeName('CodeProp')
                                      ),
                                      value: EText(''),
                                    }),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '8c144b21-a78d-8b79-7b48-7c065aae3b67',
      type: 'class',
      name: 'Pricing Overview',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4',
      type: 'class',
      name: 'Centered Heading',
      comb: '',
      styleLess: 'margin-bottom: 16px; text-align: center;',
      children: ['d857c47f-13ef-6c7e-7f97-30e5beebeba3'],
      variants: {tiny: {styleLess: 'margin-bottom: 24px;'}},
    },
    {
      _id: '9f394b53-0806-d03f-c322-35b26b4185aa',
      type: 'class',
      name: 'Pricing Description',
      comb: '',
      styleLess:
        'max-width: 550px; margin-right: auto; margin-left: auto; text-align: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'f4469efc-b695-3bd1-b5e9-8b420bdd7083',
      type: 'class',
      name: 'Pricing Grid',
      comb: '',
      styleLess:
        'display: grid; margin-top: 50px; grid-auto-columns: 1fr; grid-column-gap: 64px; grid-row-gap: 50px; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'grid-column-gap: 30px;'},
        tiny: {styleLess: 'grid-template-columns: 1fr;'},
      },
    },
    {
      _id: 'e69d9731-ab10-60ba-bae3-4b425a23b278',
      type: 'class',
      name: 'Pricing Card Three',
      comb: '',
      styleLess:
        'display: flex; flex-direction: column; justify-content: flex-start; align-items: center; text-align: center;',
      children: [],
      variants: {},
    },
    {
      _id: '6a135e2f-ce26-a9d6-d3a3-36af6d58d4b6',
      type: 'class',
      name: 'Pricing Image',
      comb: '',
      styleLess:
        'width: 80px; height: 80px; margin-bottom: 16px; object-fit: cover;',
      children: [],
      variants: {},
    },
    {
      _id: '894fc6fe-051f-d24c-68ed-7dd9b8d01d84',
      type: 'class',
      name: 'Pricing Card Text',
      comb: '',
      styleLess: 'margin-bottom: 20px;',
      children: [],
      variants: {},
    },
    {
      _id: '8829443b-f005-1554-a272-e89504531e07',
      type: 'class',
      name: 'Text Link Arrow',
      comb: '',
      styleLess:
        'display: flex; justify-content: flex-start; align-items: center; color: #1a1b1f; font-size: 14px; line-height: 20px; text-decoration: none;',
      children: [],
      variants: {},
    },
    {
      _id: '6cdfed94-50ee-a092-b160-1f9b110b78cb',
      type: 'class',
      name: 'Arrow Embed',
      comb: '',
      styleLess: 'display: flex; margin-left: 2px;',
      children: [],
      variants: {},
    },
  ],
} as const;
